import firebase from 'firebase/compat/app';
import withoutNulls from '../../api/search/withoutNulls';
import STORE_CONSTANTS from '../constants';

const converter = {
  toFirestore(tag: BonusTags.AcceptableTag): firebase.firestore.DocumentData {
    return withoutNulls({ ...tag });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusTags.AcceptableTag>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusTags.AcceptableTag {
    return {
      ...snapshot.data(options),
    };
  },
};

// Collection of SE-managed acceptable tags. Each doc carries its `dataType`, so
// callers filter per dataset with `.where('dataType', '==', dataType)` when
// listing, and address docs by id (`.doc(id)`) when adding/removing.
const getBonusTagsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_TAGS_COLLECTION)
    .withConverter(converter);
};

export default getBonusTagsRef;
